import * as React from 'react';
import MdcSelect from '../../shop-ui/components/select/MdcSelect';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import { HeaderContainer } from 'PyzShopUi/scripts/product-detail-page/components/HeaderContainer';
import { redirectToConcrete } from 'PyzShopUi/scripts/product-detail-page/includes/redirectToConcrete';
import { enableAddToCartButton } from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/addToCartButton';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { ProductLocalStoreAvailabilityEvent } from 'PyzShopUi/scripts/react/common/events/productLocalStoreAvailabilityEvent';

export const ProductMatchingBikeSelection: React.FunctionComponent<any> = props => {
    const { options, onNoRedirect, display} = props;
    const [selectedValue, setSelectedValue] = React.useState('');
    const { translate } = useTranslationHook();

    React.useEffect(() => {
        const value = options?.find((option) => option.selected === true)?.value ?? '';
        if (value !== '') {
            onChangeHandler(value);
        }
    }, [options]);

    const onChangeHandler = (value: string): void => {
        const concreteId = parseInt(value, 10);
        setSelectedValue(value);
        redirectToConcrete(concreteId);

        // if the redirect didn't happen, run the onNoRedirectCallback
        onNoRedirect();
        
        // if the url does not change while redirectToConcrete(), enable addToCartButton again
        const addToCartForm = document.querySelector<HTMLFormElement>('.add-to-cart-form');

        if (!addToCartForm) {
            return;
        }

        enableAddToCartButton(addToCartForm);

        MiddlewareEventBus.getInstance().publish({type: ProductLocalStoreAvailabilityEvent.UPDATE_CONCRETE, payload: concreteId});
    };

    return (
        <>
            {options && display &&
                <HeaderContainer headingText={translate('Choose item version', { ns: 'article-detail' })} cssClass="variant"
                    selectedValue={options.find((option) => option.value === selectedValue).label}>
                    <MdcSelect
                        key={selectedValue}
                        options={options}
                        selectedValue={selectedValue}
                        floatingLabel={translate('Item version', { ns: 'article-detail' })}
                        onChange={onChangeHandler}
                        fullWidth={true}
                    />
                </HeaderContainer>}
        </>);
};
